"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _ApiExploreCard = _interopRequireDefault(require("./ApiExploreCard"));
var _SVBButton = require("../../SVBButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders SVB Explore API
 */

/**
 * SVBExploreAPI
 * @param mainTitle: title for the component
 * @param moreButtonText: button text for the component
 * @param handleMoreButton: handler button
 * @param cardData: consists of array of objects with title, description, icon and button 
 * @param extraClasses: additional styling classes
 * @returns explore api HTML with content
 */

const SVBExploreAPI = props => {
  var _props$mainTitle, _props$moreButtonText, _props$cardData;
  const mainTitle = (_props$mainTitle = props === null || props === void 0 ? void 0 : props.mainTitle) !== null && _props$mainTitle !== void 0 ? _props$mainTitle : "";
  const moreButtonText = (_props$moreButtonText = props === null || props === void 0 ? void 0 : props.moreButtonText) !== null && _props$moreButtonText !== void 0 ? _props$moreButtonText : "View all SVB APIs";
  const handleMoreButton = props === null || props === void 0 ? void 0 : props.handleMoreButton;
  const cardData = (_props$cardData = props === null || props === void 0 ? void 0 : props.cardData) !== null && _props$cardData !== void 0 ? _props$cardData : [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "py-7 exploreApi-container bg-color-exploreAPI"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-align-center d-flex align-items-center d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "rl-font-black heading-xxlarge"
  }, mainTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "api-consumer-header-title-highlight mt-2"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "container pt-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, cardData === null || cardData === void 0 ? void 0 : cardData.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: "col-xs-6 col-md"
    }, /*#__PURE__*/_react.default.createElement(_ApiExploreCard.default, {
      title: item === null || item === void 0 ? void 0 : item.title,
      description: item === null || item === void 0 ? void 0 : item.description,
      icon: item === null || item === void 0 ? void 0 : item.icon,
      indexValue: index,
      handleButtonClick: item === null || item === void 0 ? void 0 : item.handleButtonClick
    }));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-center pt-4"
  }, /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    rightIconExtraClasses: "exploreApi-button-icon",
    extraClasses: "border-0 exploreApi-main-button  sub-heading font-family-roboto exploreApi-font-white",
    text: moreButtonText,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "down",
    iconSide: "right",
    onClick: handleMoreButton
  }))));
};
var _default = SVBExploreAPI;
exports.default = _default;